import { Box, Card, CardContent, Grid, Typography, useTheme } from "@mui/material";
import {
    TrendingUp as IncomeIcon,
    TrendingDown as ExpenseIcon,
} from '@mui/icons-material';
import React, { useEffect, useRef, useState } from "react";

import * as echarts from 'echarts';
import { green, red } from "@mui/material/colors";
import { useDataProvider } from "react-admin";

import home_icon1 from '../static/home_icon1.png';
import home_icon2 from '../static/home_icon2.png';
import home_icon3 from '../static/home_icon3.png';
import home_icon4 from '../static/home_icon4.png';

type EChartsOption = echarts.EChartsOption;

interface IncomeData {
    income: string;
    incomeRatio: string;
    trafficCustomerId: number;
    trafficCustomerLogo: string;
    trafficCustomerName: string;
}

export const IncomeStatement = (props: any) => {
    const chartRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    let chartInstance: echarts.ECharts | null = null;
    const [incomeData, setIncomeData] = useState<IncomeData[]>([]);
    const [totalIncome, setTotalIncome] = useState<number>(0);
    const dataProvider = useDataProvider();

    const [deviceIncomeTotal, setDeviceIncomeTotal] = useState<number>(0);
    const [trafficLast7daysTotal, setTrafficLast7daysTotal] = useState<number>(0);
    const [salesLast7daysTotal, setSalesLast7daysTotal] = useState<number>(0);

    const [expenditureTotal, setExpenditureTotal] = useState({ totalCashIncome: 0, totalWithdrawnCash: 0 });

    // 获取最近7天的数据
    useEffect(() => {
        const fetchDeviceIncomeTotal = async () => {
            try {
                const { data } = await dataProvider.deviceIncomeTotal();
                setDeviceIncomeTotal(data || 0);
            } catch (error) {
                console.error("获取流量收益累计总额失败:", error);
            }
        };

        const fetchExpenditureTotal = async () => {
            try {
                const { data } = await dataProvider.totalExpenditure();
                if (data) {
                    setExpenditureTotal(data);
                } else {
                    setExpenditureTotal({ totalCashIncome: 0, totalWithdrawnCash: 0 })
                }
            } catch (error) {
                console.error("获取积分结算支出总额失败:", error);
            }
        };

        const fetchData = async () => {
            try {
                const response = await dataProvider.getLast7daysList();
                if (response && response.data) {
                    setIncomeData(response.data);

                    // 计算总收入
                    const total = response.data.reduce((sum: number, item: IncomeData) => {
                        return sum + parseFloat(item.income);
                    }, 0);
                    setTotalIncome(total);
                }
            } catch (error) {
                console.error("获取最近7天数据失败:", error);
            }
        };

        const trafficLast7daysTotalInchome = async () => {
            try {
                const { data } = await dataProvider.trafficLast7daysTotalInchome();
                setTrafficLast7daysTotal(data || 0);
                console.log(data, '获取近7天流量商分配的总收益')
            } catch (error) {
                console.error("获取近7天流量商分配的总收益失败:", error);
            }
        };


        const salesLast7daysTotalInchome = async () => {
            try {
                const { data } = await dataProvider.salesLast7daysTotalInchome();
                setSalesLast7daysTotal(data || 0);
                console.log(data, '获取近7天销售商获得的总收益')
            } catch (error) {
                console.error("获取近7天销售商获得的总收益失败:", error);
            }
        };


        fetchExpenditureTotal();
        fetchDeviceIncomeTotal();
        trafficLast7daysTotalInchome();
        salesLast7daysTotalInchome();

        fetchData();
    }, []);

    useEffect(() => {
        if (chartRef.current) {
            chartInstance = echarts.init(chartRef.current);
            // console.log("incomeData:", incomeData);  // 添加日志查看实际数据

            // 修复饼图数据处理
            let pieData = [];
            if (incomeData.length === 0) {
                pieData = [{ name: '暂无数据', value: 1 }]; // 默认值
            } else {
                pieData = incomeData.map(item => ({
                    name: item.trafficCustomerName,
                    value: parseFloat(item.income),
                    incomeRatio: item.incomeRatio
                }));
            }

            // 响应式字体大小
            const isSmallScreen = window.innerWidth < 600;
            const baseFontSize = isSmallScreen ? 14 : 16;
            // console.log(trafficLast7daysTotal , salesLast7daysTotal,'????')
            let cjincom = trafficLast7daysTotal - salesLast7daysTotal
            const option: EChartsOption = {
                title: {
                    text: '近7天流量收益总额',
                    subtext: `${totalIncome.toFixed(2)}元（总收益）\n${cjincom > 0 ? (cjincom).toFixed(2) : 0}元（长嘉收益）`,
                    left: '0%',
                    top: '0%',
                    textStyle: {
                        color: '#1c3166',
                        fontWeight: 600,
                        fontSize: isSmallScreen ? 18 : 26 // 响应式字体
                    },
                    subtextStyle: {
                        fontSize: isSmallScreen ? 16 : 20, // 响应式字体
                        color: '#d44322',
                    }
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                    }
                },
                legend: {
                    left: 'left',
                    bottom: '0',
                    textStyle: {
                        color: theme.palette.text.secondary,
                        fontWeight: 'normal',
                        fontSize: baseFontSize
                    }
                },
                series: [{
                    type: 'pie',
                    radius: isSmallScreen ? ['30%', '50%'] : ['40%', '60%'], // 响应式半径
                    bottom: '20%',
                    left: '50%',
                    itemStyle: {
                        borderColor: theme.palette.background.paper,
                        borderWidth: 1
                    },
                    label: {
                        alignTo: 'edge',
                        formatter: function (params: any) {
                            return `{name|${params.name}}\n{incomeRatio|${params.data.incomeRatio}%}`;
                        },
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            name: {
                                fontSize: baseFontSize,
                                color: theme.palette.text.secondary
                            },
                            incomeRatio: {
                                fontSize: baseFontSize,
                                color: theme.palette.text.primary,
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLayout: (params) => {
                        const isLeft = params.labelRect.x < (chartInstance?.getWidth() || 0) / 2;
                        const points = params.labelLinePoints as number[][];
                        points[2][0] = isLeft
                            ? params.labelRect.x
                            : params.labelRect.x + params.labelRect.width;
                        return { labelLinePoints: points };
                    },
                    data: pieData
                }],
            };

            chartInstance.setOption(option);

            // 响应式处理
            const resizeHandler = () => {
                chartInstance?.resize();
                // 重新渲染图表以适应新尺寸
                if (chartRef.current) {
                    chartInstance?.dispose();
                    chartInstance = echarts.init(chartRef.current);
                    chartInstance.setOption(option);
                }
            };
            window.addEventListener('resize', resizeHandler);

            return () => {
                window.removeEventListener('resize', resizeHandler);
                chartInstance?.dispose();
            };
        }
    }, [theme, incomeData, totalIncome]); // 添加依赖项

    return (
        <React.Fragment>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} >
                    <Grid item xs={12} >
                        <Card >
                            <CardContent sx={{ height: 260, }}>
                                <div ref={chartRef} style={{ width: '100%', height: '100%' }} />
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* 四个卡片容器 - 手机端可水平滚动 */}
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2,
                                overflowX: 'auto',
                                pb: 1,
                                '&::-webkit-scrollbar': {
                                    display: 'none'
                                },
                                scrollbarWidth: 'none',
                                [theme.breakpoints.up('sm')]: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    overflowX: 'visible',
                                    gap: 2
                                }
                            }}
                        >
                            <Card
                                sx={{
                                    minWidth: 280,
                                    flexShrink: 0,
                                    [theme.breakpoints.up('sm')]: {
                                        minWidth: 'auto',
                                        width: '100%'
                                    }
                                }}
                            >
                                <CardContent sx={{
                                    height: 100, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <Grid container>
                                        <Grid item xs={4} sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <img
                                                src={home_icon1}
                                                alt=""
                                                style={{
                                                    height: '43px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'end',
                                            boxSizing: 'border-box',
                                        }}>
                                            <Typography variant="h6" color="#d44322">{deviceIncomeTotal}元</Typography>
                                            <Typography variant="subtitle2" color="textSecondary">流量收益总额</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Card
                                sx={{
                                    minWidth: 280,
                                    flexShrink: 0,
                                    [theme.breakpoints.up('sm')]: {
                                        minWidth: 'auto',
                                        width: '100%'
                                    }
                                }}
                            >
                                <CardContent sx={{
                                    height: 100, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <Grid container>
                                        <Grid item xs={4} sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <img
                                                src={home_icon4}
                                                alt=""
                                                style={{
                                                    height: '43px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'end',
                                            boxSizing: 'border-box',
                                        }}>
                                            <Typography variant="h6" color="#d44322">{(deviceIncomeTotal - expenditureTotal.totalCashIncome).toFixed(2)}元</Typography>
                                            <Typography variant="subtitle2" color="textSecondary">长嘉收益总额</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Card
                                sx={{
                                    minWidth: 280,
                                    flexShrink: 0,
                                    [theme.breakpoints.up('sm')]: {
                                        minWidth: 'auto',
                                        width: '100%'
                                    }
                                }}
                            >
                                <CardContent sx={{
                                    height: 100, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <Grid container>
                                        <Grid item xs={4} sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <img
                                                src={home_icon2}
                                                alt=""
                                                style={{
                                                    height: '43px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'end',
                                            boxSizing: 'border-box',
                                        }}>
                                            <Typography variant="h6" color="#d44322">{expenditureTotal.totalCashIncome}元</Typography>
                                            <Typography variant="subtitle2" color="textSecondary">设备商分成总额</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Card
                                sx={{
                                    minWidth: 280,
                                    flexShrink: 0,
                                    [theme.breakpoints.up('sm')]: {
                                        minWidth: 'auto',
                                        width: '100%'
                                    }
                                }}
                            >
                                <CardContent sx={{
                                    height: 100, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <Grid container>
                                        <Grid item xs={4} sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <img
                                                src={home_icon3}
                                                alt=""
                                                style={{
                                                    height: '43px',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'end',
                                            boxSizing: 'border-box',
                                        }}>
                                            <Typography variant="h6" color="#d44322">{expenditureTotal.totalWithdrawnCash}元</Typography>
                                            <Typography variant="subtitle2" color="textSecondary">设备商提现总额</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment >
    );
};